
import { Button, FloatingLabel, Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import useDomicilio from '../hooks/useDomicilio';
import FlexCenter from './FlexCenter';
import { Toast } from './Toast';
import { Toaster } from 'react-hot-toast';


const Domicilio = () => {

    const { guardarDomicilio, formDomicilio, setFormDomicilio, cargando } = useDomicilio()

    return (
        <div className='my-4'>
            <hr className='m-5'/>

                <p className='lead text-center'>Domicilio</p>


                <Row>
                    <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingSelect' label='Calle' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.calle }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, calle: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingInput1' label='Número' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.numero }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, numero: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingInput1' label='Ciudad' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.ciudad }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, ciudad: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingInput1' label='Estado' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.estado }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, estado: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingInput1' label='Código postal' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.codigoPostal }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, codigoPostal: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingInput1' label='Colonia' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.colonia }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, colonia: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col>
                    {/* <Col xs={12} xl={6}>
                        <FloatingLabel controlId='floatingInput1' label='Código fiscal' className='mb-3'>
                            <Form.Control
                                placeholder=' '
                                autoComplete='off'
                                value={ formDomicilio.codigoFiscal }
                                onChange={ (e) => setFormDomicilio({ ...formDomicilio, codigoFiscal: e.target.value }) }
                            />
                        </FloatingLabel>
                    </Col> */}
                </Row>

                <FlexCenter>
                    <Button onClick={ guardarDomicilio } disabled={ cargando }>
                        { ( cargando ) ? "Guardando" : "Guardar cambios" }
                    </Button>
                </FlexCenter>

            <Toast texto='Error al traer los datos de tu domicilio. Puedes revisar tu conexión o iniciar sesión nuevamente.'/>
            <Toaster/>
        </div>
    )
}

export default Domicilio
